import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { REACT_APP_APP_INSIGHT_CONNECTION_STRING } from '../services/config';

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
    config: {
        connectionString: REACT_APP_APP_INSIGHT_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: null }
        }
    }
});

export const initializeTelemetry = (connectionString: string, browserHistory: any) => {
    if (!connectionString) {
        throw new Error('Instrumentation key not provided');
    }

    if (!browserHistory) {
        throw new Error('Could not initialize Telemetry Service');
    }

    appInsights.config.connectionString = connectionString;
    if (appInsights.config.extensionConfig) {
        appInsights.config.extensionConfig[reactPlugin.identifier].history = browserHistory;
    }
    if (!appInsights.core.isInitialized!) {
        appInsights.loadAppInsights();
    }
    appInsights.trackPageView();
};

export { appInsights, reactPlugin };